import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { loadAllContacts } from '@disco/state-management/actions/contact-actions'
import { getContactsAll } from '@disco/state-management/selectors/contacts-all'

import DocumentHeadTags from 'components/document-head-tags'

import NewCampaignModal from 'pages/campaigns/new-campaign-modal'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  children?: React.ReactNode
}

const CampaignsPage = ({ children }: Props): React.ReactElement<'div'> => {
  const { loading, loaded } = useSelector(getContactsAll)
  const dispatch = useDispatch()
  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(loadAllContacts())
    }
  }, [])
  return (
    <div className="Page">
      <DocumentHeadTags title="Campaigns | DISCO" />
      <Outlet />
      <NewCampaignModal />
    </div>
  )
}

export default CampaignsPage
